import PptxGenJS from "pptxgenjs"
import { splitTextInRect } from 'shared/util'

import { KojinPptxComponentsProps } from '../types'

const organListLayout = {
  width: 7,
  lineHeight: 0.25,
  margin: {
    cx: 0.28,
    cy: 0
  }
}

type organListProps = KojinPptxComponentsProps & {
  top: number
}
type organListReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const organList = ({
  top,
  ...other
}: organListProps): organListReturnValue => {
  const { layout, slide, kojin } = other
  if (!kojin || !kojin.organ || kojin.organ.length === 0) return { slide, bottom: top }

  const texts: PptxGenJS.TextProps[] = kojin.organ.map((organ) => {
    const words = [
      organ.sisetuName,
      organ.bukaName,
      (organ.positionRank ?? 0) < 7500 ? organ.yakusyokuName : null
    ].filter((word) => word !== null && word !== undefined && word !== '')

    return {
      text: words.join(' '),
      options: {
        ...layout.textOption,
        color: '808080',
        breakLine: true,
        lineSpacing: layout.baseFont.fontSize * 1.5,
        wrap: true
      }
    }
  })
  const height = texts.reduce((h, line) => {
    const lines = splitTextInRect(
      line.text ?? '', layout.baseFont.fontSize, layout.baseFont.fontFace, 
      (organListLayout.width - (organListLayout.margin.cx + organListLayout.margin.cx)) * layout.inchPerDot
    ) || []
    return h + 
      organListLayout.margin.cy + 
      (organListLayout.lineHeight * Math.max(1, lines.length)) + 
      organListLayout.margin.cy
  }, 0)

  const options: PptxGenJS.TextPropsOptions = {
    x: 0, y: top + layout.margin,
    h: height,
    w: organListLayout.width,
    margin: [20, 10, 0, 0],
    align: 'left', valign: 'top'
  }
  slide.addText(texts, options)
  return {
    slide,
    bottom: top + layout.margin + height
  }
}
